/* eslint-disable react/jsx-no-bind */
import clsx from 'clsx'
import styleUtils from 'shared-components/styles/util.module.css'
import PageExcerpt from 'shared-components/ui/PageExcerpt'
import SendNewsletterForm from 'shared-components/form/SendNewsletterForm'
import NewsletterBlock from 'shared-components/ui/NewsletterBlock'
import { htmlReactParse } from 'shared-code/html'
import styles from './NewslettersCatalogTemplate.module.css'
import { useSet } from 'shared-components/hooks/use-set'
import { DSNewslettersCatalog, DSSubmitSubscribe } from 'shared-definitions/types'

interface NewslettersCatalogTemplateProps {
  page: DSNewslettersCatalog
  company: string
  submitting: boolean
  submit: (params: Omit<DSSubmitSubscribe, 'vars'>) => Promise<boolean>
}

const NewslettersCatalogTemplate: React.VFC<NewslettersCatalogTemplateProps> = ({
  submit,
  submitting,
  company,
  page,
}) => {
  const { add: addChoice, remove: removeChoice, set: choosen } = useSet<string>()

  return (
    <div className={styleUtils.wrapper}>
      <h1 className={clsx(styleUtils.pageTitleMargins, styleUtils.pageTitle)}>{page.title}</h1>
      <PageExcerpt className={styles.excerpt}>{htmlReactParse(page.textHtml)}</PageExcerpt>
      <div className={styles.grid}>
        {page.choices.map((item, index) => {
          const active = item.listIds.every(i => choosen.has(i))
          return (
            <NewsletterBlock
              disableSubscribe={page.disableSubscribe}
              company={company}
              key={index}
              block={item}
              onChoose={() => (active ? removeChoice(item.listIds) : addChoice(item.listIds))}
              active={active}
            />
          )
        })}
      </div>
      {!page.disableSubscribe && (
        <SendNewsletterForm
          onSubmit={email => submit({ email, choices: Array.from(choosen) })}
          className={clsx(styles.form, { [styles.formSubmitting]: submitting })}
          active={choosen.size > 0}
          placeholder={'email address'}
          button={'Sign me up!'}
        />
      )}
    </div>
  )
}

export default NewslettersCatalogTemplate
